module.exports = __webpack_public_path__ + "static/media/img_22.8d8de5b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_22.jpg
// module id = 541
// module chunks = 0